module.exports = __webpack_public_path__ + "static/img/animales_35.4fa5dc63.png";